module.exports = __webpack_public_path__ + "img/slide-1.8aedfa41.png";